import React from "react";
import { MapPin } from "lucide-react";

import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Link } from "react-router";
import { Location } from "@/types/fse";

interface LocationsModalProps {
  itemName: string;
  locations: Location[];
}

const LocationsModal: React.FC<LocationsModalProps> = ({ itemName, locations }) => (
  <Dialog>
    <DialogTrigger asChild>
      <Button variant="light-beige-secondary" size="xs" className="px-2 py-1 text-xs">
        <MapPin className="h-3 w-3" />
      </Button>
    </DialogTrigger>
    <DialogContent className="w-full max-w-screen-md">
      <DialogHeader>
        <DialogTitle className="break-words">Locations for {itemName}</DialogTitle>
      </DialogHeader>
      <div className="mt-4">
        {locations.map(location => (
          <Link
            to={`/drive/${location.id}`}
            key={location.id}
            className="mb-2 block rounded bg-gray-100 p-2 transition-colors hover:bg-gray-200"
          >
            <div className="flex items-start">
              <MapPin className="mr-2 h-4 w-4 flex-shrink-0 text-gray-500" />
              <div className="flex-1">
                <p className="break-words text-sm font-medium">Location ID: {location.id}</p>
                <p className="break-words text-xs text-gray-600">Path: {location.path.map(p => p.name).join(" / ")}</p>
              </div>
            </div>
          </Link>
        ))}
      </div>
    </DialogContent>
  </Dialog>
);

export default LocationsModal;
